(async function () {
  const BONUS_IDS = [42270246961338];
  const MIN_PAID_ITEMS_FOR_GIFT = 3;
  const DEBOUNCE_MS = 300;

  let syncing = false;
  let debounceTimer = null;
  let lastCartState = null; // ← NOVO: cache do último estado

  // Gera hash simples do carrinho para detectar mudanças reais
  function getCartHash(cart) {
    const items = cart.items.map(i => `${i.id}:${i.quantity}:${i.properties?.gift_item || ''}`).sort().join('|');
    return items;
  }

  // --- Helpers de Cart ---
  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!res.ok) throw new Error('Failed to load cart');
    return await res.json();
  }

  function isGiftLineStrict(item) {
    return BONUS_IDS.includes(item.id) && item.properties?.gift_item === 'true';
  }

  function countPaidItems(cart) {
    return cart.items.reduce((sum, it) => sum + (isGiftLineStrict(it) ? 0 : it.quantity), 0);
  }

  function getGiftLinesStrict(cart) {
    return cart.items.filter(isGiftLineStrict);
  }

  async function addGifts(missingBonusIds) {
    if (!missingBonusIds.length) return false;
    
    console.log('🎁 Adding gifts:', missingBonusIds); // ← DEBUG
    
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: missingBonusIds.map((id) => ({
          id,
          quantity: 1,
          properties: { gift_item: 'true' },
        })),
      }),
    });
    
    if (!res.ok) throw new Error('Failed to add gifts');
    return true;
  }

  async function removeAllStrictGifts(cart) {
    const strict = getGiftLinesStrict(cart);
    if (!strict.length) return false;

    console.log('🗑️ Removing gifts:', strict.map(l => l.key)); // ← DEBUG

    const updates = {};
    for (const line of strict) updates[line.key] = 0;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates }),
    });
    return true;
  }

  async function splitExcessGiftQuantityIntoPaid(cart) {
    const strict = getGiftLinesStrict(cart);
    const tasks = [];

    for (const line of strict) {
      if (line.quantity > 1) {
        console.log('✂️ Splitting excess gift qty:', line.quantity); // ← DEBUG
        const extraQty = line.quantity - 1;
        
        tasks.push(
          Promise.all([
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: line.key, quantity: 1 }),
            }),
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: [{ id: line.id, quantity: extraQty }] }),
            }),
          ])
        );
      }
    }

    if (!tasks.length) return false;
    await Promise.all(tasks);
    return true;
  }

  async function normalizeGiftQuantities(cart) {
    const dirty = getGiftLinesStrict(cart).filter((l) => l.quantity !== 1);
    if (!dirty.length) return false;
    
    console.log('🔧 Normalizing gift quantities'); // ← DEBUG
    
    const updates = {};
    for (const l of dirty) updates[l.key] = 1;
    
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates }),
    });
    return true;
  }

  async function syncBonusNow() {
    if (syncing) {
      console.log('⏳ Already syncing, skipping'); // ← DEBUG
      return;
    }
    
    syncing = true;
    console.log('🔄 Sync started'); // ← DEBUG

    try {
      const cart = await fetchCart();
      const currentHash = getCartHash(cart);
      
      // ← NOVO: Previne processar o mesmo estado 2x
      if (currentHash === lastCartState) {
        console.log('✅ Cart unchanged, skipping'); // ← DEBUG
        return;
      }
      
      lastCartState = currentHash;
      
      const paidCount = countPaidItems(cart);
      console.log('📊 Paid items:', paidCount); // ← DEBUG
      let mutated = false;

      if (paidCount >= MIN_PAID_ITEMS_FOR_GIFT) {
        const presentStrictIds = new Set(getGiftLinesStrict(cart).map((l) => l.id));
        const missingIds = BONUS_IDS.filter((id) => !presentStrictIds.has(id));
        
        if (missingIds.length) {
          await addGifts(missingIds);
          mutated = true;
        }

        const mutatedSplit = await splitExcessGiftQuantityIntoPaid(cart);
        mutated = mutated || mutatedSplit;

        if (mutatedSplit) {
          await new Promise(resolve => setTimeout(resolve, 200)); // ← Aguarda estabilizar
          const cart2 = await fetchCart();
          const mutatedNorm = await normalizeGiftQuantities(cart2);
          mutated = mutated || mutatedNorm;
        }
      } else {
        mutated = await removeAllStrictGifts(cart);
      }

      if (mutated) {
        lastCartState = null; // ← Força revalidação na próxima
        if (window.CartJS && typeof CartJS.getCart === 'function') {
          await CartJS.getCart();
          reloadSection('v3-cart')
        }
      }
      
      console.log('✅ Sync completed, mutated:', mutated); // ← DEBUG
    } catch (err) {
      console.error('❌ Sync error:', err); // ← DEBUG visível
      lastCartState = null; // ← Reset em caso de erro
    } finally {
      syncing = false;
    }
  }

  function syncBonusDebounced() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncBonusNow, DEBOUNCE_MS);
  }

  // Previne múltiplos bindings
  $(document).off('cart.requestComplete', syncBonusDebounced);
  $(document).on('cart.requestComplete', syncBonusDebounced);

  // Inicial
  setTimeout(syncBonusNow, 300);
})();